import { closeModalByName, ExitModal, requestResourceByName, useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

export interface ConfirmDeleteMessageProps {
  isMultiple?: boolean;
}

const ConfirmDeleteMessage: FC<ConfirmDeleteMessageProps> = ({ isMultiple = false }) => {
  const { t } = useTranslation('DeleteMessagesButton');
  const dispatch = useDispatch();
  const pending: boolean = useScopedSelector('deleteMessagesResource.pending');

  return (
    <ExitModal
      modalTitle={isMultiple ? t('modalMultipleDeleteText') : t('modalDeleteText')}
      modalMessage={null}
      name="confirmDeleteMessage"
      onCancel={() => { dispatch(closeModalByName('confirmDeleteMessage')); }}
      confirmButton={t('modalDeleteConfirmButtonText')}
      onConfirm={() => {
        dispatch(requestResourceByName('deleteMessagesResource'));
        dispatch(closeModalByName('confirmDeleteMessage'));
      }}
      confirmBusy={pending}
      cancelDisabled={pending}
    />
  );
};

export default ConfirmDeleteMessage;
